const canUse = () => typeof localStorage !== 'undefined'

export default canUse
